import {
  action, makeAutoObservable, observable, when,
} from 'mobx';
import { getLegacyGoToAuth } from './utils';
import { CartSdkConfig } from './cart';
import { CartSdkStore } from './cart/store';
import { SdkStoreConfig } from './types';

class SdkStore {
  @observable public cart?: CartSdkStore = undefined;

  @observable private goToAuthHandler?: SdkStoreConfig['goToAuth'] = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  public async init(config: SdkStoreConfig): Promise<void> {
    await Promise.all([
      this.initGoToAuth(config.goToAuth),
      this.initCartStore(config.cart),
    ]);
  }

  @action
  private async initCartStore(config?: CartSdkConfig): Promise<CartSdkStore> {
    if (config) {
      this.cart = new CartSdkStore(config);
    } else {
      const { AppStore } = await import('@gamiphy/loyalty-station-desktop/store/app');
      await when(() => AppStore.initialized);

      this.cart = CartSdkStore.getLegacyCartSdk(AppStore.app.agent);
    }

    return this.cart;
  }

  @action
  private async initGoToAuth(goToAuth?: SdkStoreConfig['goToAuth']): Promise<void> {
    const { AppStore } = await import('@gamiphy/loyalty-station-desktop/store/app');
    await when(() => AppStore.initialized);

    if (goToAuth && AppStore.app.agent !== 'vtex') {
      this.goToAuthHandler = goToAuth;
    } else {
      this.goToAuthHandler = getLegacyGoToAuth(AppStore.app.agent);
    }
  }

  @action
  public async goToAuth(isSignUp: boolean): Promise<void> {
    const { ThemeStore } = await import('@gamiphy/loyalty-station-desktop/store/theme');

    if (isSignUp && ThemeStore.theme?.memberAccess?.signUpUrl) {
      window.location.href = ThemeStore.theme?.memberAccess?.signUpUrl;
    } else if (!isSignUp && ThemeStore.theme?.memberAccess?.signInUrl) {
      window.location.href = ThemeStore.theme?.memberAccess?.signInUrl;
    } else {
      this.goToAuthHandler?.(isSignUp);
    }
  }
}

export default new SdkStore();
